export default "__VITE_ASSET__DgXRoLe8__"